import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { CustomerDataDTO } from '../../../../common/types/dto/CustomerDataDTO';
import { ConfigProp, RenderPropWithProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';

export interface CustomerInfoProps extends ConfigProp {
    firstName: string;
    lastName: string;
    address: string;
    addressNumber: string;
    addressFloor: string;
    city: string;
    postalCode: string;
    phoneNumber: string;
}

export interface CustomerInfoContainerProps {
}

interface ReduxStateProps {
    isCommunicating: boolean;
    customerInfo: CustomerDataDTO | undefined;
}

interface CustomerInfoContainerState {
    firstName: string;
    lastName: string;
    address: string;
    addressNumber: string;
    addressFloor: string;
    city: string;
    postalCode: string;
    phoneNumber: string;
}

class CustomerInfoContainer extends Component<
    CustomerInfoContainerProps &
    TranslationFuncProp &
    RenderPropWithProps<CustomerInfoProps> &
    ReduxStateProps,
    CustomerInfoContainerState
    > {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        isCommunicating: PropTypes.bool.isRequired,
        customerInfo: PropTypes.any,
        //
        children: PropTypes.func.isRequired,
    };

    public readonly state: CustomerInfoContainerState = {
        firstName: '',
        lastName: '',
        address: '',
        addressNumber: '',
        addressFloor: '',
        city: '',
        postalCode: '',
        phoneNumber: '',
    };

    public componentWillReceiveProps(nextProps: ReduxStateProps) {
        this.handleInit(nextProps);
    }

    public componentDidMount() {
        this.handleInit(this.props);
    }

    public handleInit(nextProps: ReduxStateProps) {
        if (nextProps.customerInfo) {
            this.setState({
                firstName: nextProps.customerInfo.firstName || this.state.firstName,
                lastName: nextProps.customerInfo.lastName || this.state.lastName,
                address: nextProps.customerInfo.address || this.state.address,
                addressNumber: nextProps.customerInfo.addressNumber || this.state.addressNumber,
                addressFloor: nextProps.customerInfo.addressFloor || this.state.addressFloor,
                city: nextProps.customerInfo.city || this.state.city,
                postalCode: nextProps.customerInfo.postalCode || this.state.postalCode,
                phoneNumber: nextProps.customerInfo.phoneNumber || this.state.phoneNumber,
            });
        }
    }

    public render() {
        const newProps: CustomerInfoProps = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            address: this.state.address,
            addressFloor: this.state.addressFloor,
            addressNumber: this.state.addressNumber,
            city: this.state.city,
            phoneNumber: this.state.phoneNumber,
            postalCode: this.state.postalCode,
            config,
        };

        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.customerState.updateCustomer.isCommunicating,
    customerInfo: store.customerState.customerData.data.customerData,
});

export default connect(mapStateToProps)(CustomerInfoContainer);
